import { Instance } from "./Base";

export default class ButtonElement implements Instance {
  private instance: HTMLButtonElement;

  constructor(name: string,
              value: string = "",
              classes: string[] = [],
              onClick: Function) {
    this.instance = document.createElement("button");
    this.instance.setAttribute("type", "button");
    this.instance.setAttribute("name", name);
    this.instance.setAttribute("id", name);
    this.instance.innerHTML = value;
    this.instance.classList.add(...classes);
    this.instance.addEventListener("click", () => onClick())
  }

  get element(): HTMLElement {
    return this.instance;
  }
}
